import React, { useEffect } from 'react'
import ExpiredLink from 'assets/images/link-expired.png'
import useService from 'hooks/useService'

const LinkExpired = () => {
    const { clearStorageData } = useService()

    useEffect(() => {
        clearStorageData()
    }, [])

    return (
        <div className='d-flex justify-content-center align-items-center h-100'>
            <img src={ExpiredLink} className='scheckout-img' />
        </div>
    )
}

export default LinkExpired